import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/fonts/iconfont/iconfont.css'
import { dispatchEventStroage } from "./utils/overwrite"
import 'font-awesome/css/font-awesome.min.css';
import VueMeta from 'vue-meta'
import screenResizeMixin from './mixins/screenResizeMixin'

Vue.mixin(screenResizeMixin)
Vue.use(ElementUI);
Vue.config.productionTip = false
dispatchEventStroage()
Vue.use(VueMeta, {
  // 可选配置
  keyName: 'metaInfo', // 组件中使用的选项名称，默认是 metaInfo
  refreshOnceOnNavigation: true,
  attribute: 'data-vue-meta', // vue-meta 添加的标签属性
  ssrAttribute: 'data-vue-meta-server-rendered', // SSR 使用的属性
  tagIDKeyName: 'vmid' // 用于标识标签的 key
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  // 获取屏幕宽度
  const screenWidth = window.innerWidth

  // 定义跳转规则
  if (screenWidth < 768 && to.path !== '/mobile') {
    // 如果屏幕宽度小于768px且当前不是移动端路由，则跳转到移动端页面
    next('/mobile')
  } else if (screenWidth >= 768 && to.path === '/mobile') {
    // 如果屏幕宽度大于等于768px且当前是移动端路由，则跳转到PC端页面
    next('/')
  } else {
    // 否则正常跳转
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
